import { ParentSize } from '@visx/responsive';
import * as React from 'react';

import { CountryMap } from './CountryMap';

export function CountryChart({
  countries,
}: {
  countries: { country: string; value: number }[];
}) {
  return (
    <div className="flex h-full flex-col gap-3 rounded-8 border border-[var(--media-kit-background-alpha)] bg-[var(--media-kit-background-primary)] p-4">
      <h3 className="text-16 font-500 text-[var(--media-kit-text-base)]">
        Country distribution
      </h3>
      <div className="flex size-full flex-col items-center gap-3">
        <ParentSize>
          {({ width }) => (
            <CountryMap width={width} height={185} data={countries} />
          )}
        </ParentSize>
        <div className="flex w-full flex-col gap-1">
          {countries.map((c) => (
            <div className="flex items-center gap-2" key={c.country}>
              <span className="text-16 font-500 text-[var(--media-kit-text-base)]">
                {c.value}%
              </span>
              <span className="text-16 text-[var(--media-kit-text-subtle)]">
                {c.country}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
